import { render, staticRenderFns } from "./hotelBooking.vue?vue&type=template&id=9d5267d0"
import script from "./hotelBooking.vue?vue&type=script&lang=js"
export * from "./hotelBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports